import { render, staticRenderFns } from "./AssetNew.vue?vue&type=template&id=2b4e51f8"
import script from "./AssetNew.vue?vue&type=script&lang=js"
export * from "./AssetNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports